import React from "react";
import { useFormContext } from "react-hook-form";

import BoxingTableContextMenu from "../ContextMenuItems/BoxingTableContextMenu";
import { BOX_TYPES } from "../../../constants/boxing";

import { BoxHubHookFormSelect, HubHookFormInput } from "../../../components";

import { StyledCell } from "../styles";
import { StyledBoxStack } from "./styles";

const ShipmentBoxesTableRow = ({ idx, item, remove = () => {}, disabled }) => {
  const prefix = `boxes.${idx}`;

  const { getValues, setValue } = useFormContext();

  const onDelete = () => {
    remove(idx);
    handleWeightChange();
  };

  const handleBoxChange = () => {
    const size = getValues(`${prefix}.size`);
    const box = BOX_TYPES?.find((box) => box.id === size);
    setValue(`${prefix}.height`, box?.h);
  };

  const handleWeightChange = () => {
    const boxes = getValues("boxes");
    const weight = boxes.reduce(
      (tol, curr) => tol + curr.quantity * curr.weight,
      0,
    );
    setValue("weight", weight);
  };

  return (
    <StyledBoxStack>
      <BoxHubHookFormSelect
        name={`${prefix}.size`}
        defaultValue={item?.size}
        onChange={handleBoxChange}
        disabled={disabled}
        required
      />
      <HubHookFormInput
        name={`${prefix}.height`}
        defaultValue={item?.height}
        endAdornment="in"
        disabled={disabled}
        required
        isNumber
      />
      <HubHookFormInput
        name={`${prefix}.quantity`}
        defaultValue={item?.quantity}
        onBlur={handleWeightChange}
        endAdornment="pkgs"
        disabled={disabled}
        placeholder="# of identical packages"
        required
        isNumber
      />
      <HubHookFormInput
        name={`${prefix}.weight`}
        defaultValue={item?.weight}
        onBlur={handleWeightChange}
        endAdornment="lbs"
        disabled={disabled}
        required
        isNumber
      />
      <StyledCell>
        <BoxingTableContextMenu hideSerialize idx={idx} onDelete={onDelete} />
      </StyledCell>
    </StyledBoxStack>
  );
};

export default ShipmentBoxesTableRow;
